import { createAction, createAsyncAction } from "typesafe-actions";
import { PaginatedResponse, PropertiesFilter, ResponseError } from "@shared/interfaces";
import { Property } from "@shared/interfaces/Property";

import { PropertiesActionTypes } from "./constants";

export const getProperties = createAsyncAction(
  PropertiesActionTypes.GET_PROPERTIES,
  PropertiesActionTypes.GET_PROPERTIES_SUCCESS,
  PropertiesActionTypes.GET_PROPERTIES_FAILURE,
)<PropertiesFilter, PaginatedResponse<Property>, ResponseError>();

export const getPropertiesCsv = createAsyncAction(
  PropertiesActionTypes.GET_PROPERTIES_CSV,
  PropertiesActionTypes.GET_PROPERTIES_CSV_SUCCESS,
  PropertiesActionTypes.GET_PROPERTIES_CSV_FAILURE,
)<PropertiesFilter, null, ResponseError>();

export const getProperty = createAsyncAction(
  PropertiesActionTypes.GET_PROPERTY,
  PropertiesActionTypes.GET_PROPERTY_SUCCESS,
  PropertiesActionTypes.GET_PROPERTY_FAILURE,
)<number, Property, ResponseError>();

export const checkIfPropertyCouldBeAssignedToLead = createAsyncAction(
  PropertiesActionTypes.CHECK_IF_PROPERTY_COULD_BE_ASSIGNED_TO_LEAD,
  PropertiesActionTypes.CHECK_IF_PROPERTY_COULD_BE_ASSIGNED_TO_LEAD_SUCCESS,
  PropertiesActionTypes.CHECK_IF_PROPERTY_COULD_BE_ASSIGNED_TO_LEAD_FAILURE,
)<number, Property, ResponseError>();

export const assignedToLead = createAsyncAction(
  PropertiesActionTypes.ASSIGN_TO_LEAD,
  PropertiesActionTypes.ASSIGN_TO_LEAD_SUCCESS,
  PropertiesActionTypes.ASSIGN_TO_LEAD_FAILURE,
)<{ propertyId: number; leadId: number; callback?: () => void }, Property, ResponseError>();

export const selectProperty = createAction(PropertiesActionTypes.SELECT_PROPERTY)<number>();
export const unselectProperty = createAction(PropertiesActionTypes.UNSELECT_PROPERTY)<number>();

export const selectAllProperties = createAction(PropertiesActionTypes.SELECT_ALL_PROPERTIES)();
export const unselectAllProperties = createAction(PropertiesActionTypes.UNSELECT_ALL_PROPERTIES)();

export const setFilter = createAction(PropertiesActionTypes.SET_FILTER)<Partial<PropertiesFilter> | null>();

export const clearErrors = createAction(PropertiesActionTypes.CLEAR_ERRORS)<Property[] | void>();
